// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1429":"760b75c2","1859":"760b75c2","2924":"760b75c2","3736":"760b75c2","6120":"760b75c2","8408":"760b75c2"}[chunkId] + ".chunk.css";
};